<template>
  <div class="loading-page">
    <div class="loading-content">
      <!-- Logo 区域 -->
      <div class="logo-section">
        <div class="logo-wrapper">
          <img src="../assets/badge.png" class="logo-image" />
        </div>
        <div class="brand-name"> <img src="../assets/name_long.png" style="width: 80%; margin-left: 10%;"></div>
        <!-- <img src="../assets/name_long.png" style="width: 80%; margin-left: 10%;"> -->
        <div class="brand-slogan"></div>
        <img src="../assets/xx.png" style="width: 50%;">
      </div>

      <!-- 加载动画 -->
      <div class="loading-section">
        <div class="loading-spinner">
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
        </div>
        <div class="loading-text">正在加载中...</div>
      </div>
    </div>

    <!-- 底部装饰 -->
    <div class="bottom-decoration">
      <div class="decoration-line"></div>
      <div class="decoration-text">永春第一中学</div>
      <div class="decoration-line"></div>
    </div>
  </div>
</template>

<script>
import { wxLogin } from '@/api/load';
import { Toast } from 'vant';
export default {
  name: 'app',
  data() {
    return {};
  },
  methods: {
    getUrlKey(name) {
      return (
        decodeURIComponent(
          (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
            location.href
          ) || [null, ''])[1].replace(/\+/g, '%20')
        ) || null
      );
    },
    doLogin(code) {
      let data = { openId: code };
      wxLogin(data)
        .then((res) => {
          if (res.code == 200) {
            localStorage.setItem('token', res.data);
            this.$router.push('/home');
          } else {
            Toast.fail('授权失败，请稍后重试');
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  created() {
    let code = this.getUrlKey('openId');
    if (!code) {
      window.location.href =
        'https://ycwx.fjnx.com.cn/wechat/meritbox?redirect_url=https://ycyz.h5.hscarstop.cn?state=w';
    } else {
      setTimeout(() => {
        this.doLogin(code);
      }, 1500);
    }
  },
};
</script>

<style lang="less" scoped>
@primary: #8b1a2b;
@primary-light: #b83245;
@primary-dark: #6b1321;
@bg: #faf7f2;

.loading-page {
  min-height: 100vh;
  background: @bg;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -80px;
}

// Logo 区域
.logo-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 60px;

  .logo-wrapper {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 20px rgba(139, 26, 43, 0.15);
    margin-bottom: 20px;
    border: 3px solid rgba(139, 26, 43, 0.1);

    .logo-image {
      width: 80px;
      height: 80px;
      object-fit: contain;
    }
  }

  .brand-name {
    font-size: 22px;
    font-weight: bold;
    color: @primary;
    letter-spacing: 3px;
    margin-bottom: 8px;
  }

  .brand-slogan {
    font-size: 14px;
    color: #9b8b7b;
    letter-spacing: 2px;
  }
}

// 加载动画区域
.loading-section {
  display: flex;
  flex-direction: column;
  align-items: center;

  .loading-spinner {
    position: relative;
    width: 50px;
    height: 50px;
    margin-bottom: 16px;

    .spinner-ring {
      position: absolute;
      border: 3px solid transparent;
      border-top-color: @primary;
      border-radius: 50%;
      animation: spin 1.2s linear infinite;

      &:nth-child(1) {
        width: 50px;
        height: 50px;
        top: 0;
        left: 0;
        animation-duration: 1.2s;
      }

      &:nth-child(2) {
        width: 36px;
        height: 36px;
        top: 7px;
        left: 7px;
        animation-duration: 0.9s;
        border-top-color: @primary-light;
      }

      &:nth-child(3) {
        width: 22px;
        height: 22px;
        top: 14px;
        left: 14px;
        animation-duration: 0.6s;
        border-top-color: @primary-dark;
      }
    }
  }

  .loading-text {
    font-size: 14px;
    color: #666;
    letter-spacing: 1px;
  }
}

// 底部装饰
.bottom-decoration {
  position: absolute;
  bottom: 40px;
  display: flex;
  align-items: center;
  gap: 12px;

  .decoration-line {
    width: 40px;
    height: 1px;
    background: linear-gradient(90deg, transparent, #ccc, transparent);
  }

  .decoration-text {
    font-size: 12px;
    color: #999;
    letter-spacing: 1px;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
